import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Not Set' },
    { value: 2, label: 'Developing' },
    { value: 3, label: 'Secure' },
  ],
});
